import '../../style/index.css';
import './index.css';
// style dependencies
import '../../radio/style/css';
import '../../checkbox/style/css';
import '../../dropdown/style/css';
import '../../spin/style/css';
import '../../pagination/style/css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/style/css.js
// module id = 26
// module chunks = 0